import { render, staticRenderFns } from "./colorStyle.vue?vue&type=template&id=b9542778&scoped=true&"
import script from "./colorStyle.vue?vue&type=script&lang=js&"
export * from "./colorStyle.vue?vue&type=script&lang=js&"
import style0 from "./colorStyle.vue?vue&type=style&index=0&id=b9542778&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9542778",
  null
  
)

export default component.exports